<template>
  <ChartCustom :chart-settings="chartConfig" :dimensions="dimensions"></ChartCustom>
</template>

<script>
  import lodash from 'lodash';
  import ChartCustom from '../../../general/ChartCustom.vue';
  import DataMethods from '../../../utils/DataMethods';

  export default {
    name: 'LocationSummaryChart',
    mixins: [DataMethods],
    components: {
      ChartCustom,
    },
    props: ['location', 'axis', 'max', 'min'],
    computed: {
      unitTypes() {
        return [
          'premium_units',
          'advanced_units',
          'basic_units',
          'entry_units',
          'cros_units',
        ]
      },
      dimensions() {
        return {
          height: 350,
        };
      },
      formattedData() {
        return [{
          ...this.location.totals,
          name: this.location.name,
          abs_units: lodash.reduce(this.location.totals, (sum, total, key) => {
            return this.unitTypes.includes(key) ? sum +  Math.abs(total) : sum;
          }, 0)
        }];
      },
      chartConfig() {
        const formattedData = this.formattedData;
        const self = this;
        return {
          size: {
            height: 350,
          },
          data: {
            json: formattedData,
            type: 'bar',
            labels: {
              format: function(v, id, i, j) {
                if (v > 0 && id != undefined) {
                  if (id != undefined) {
                    let percRaw = parseInt(v) / (parseInt(formattedData[i]['abs_units']) || 1);
                    let perc = self.round(percRaw * 100);
                    return perc+'%';
                  }
                  return v;
                }
                return '';
              }
            },
            names: {
              premium_units: 'Premium',
              advanced_units: 'Advanced',
              basic_units: 'Basic',
              entry_units: 'Entry',
              cros_units: 'CROS',
            },
            keys: {
              x: 'name',
              value: this.unitTypes.reverse(),
            },
            groups: [
              this.unitTypes.reverse(),
            ],
            colors: {
              premium_units: '#1EAEFF',
              advanced_units: '#80BD4D',
              basic_units: '#D87E00',
              entry_units: '#E9CA1E',
              cros_units: '#1B75BB'
            },
            order: null,
          },
          axis: {
            x: {
              type: 'category',
              show: false,
            },
            y: {
              show: false,
              max: parseInt(this.max),
              min: parseInt(this.min),
            },
            y2: {
              show: false
            },
          },
          grid: {
            y: {
              lines: [
                {value: 0, text: ''},
              ]
            }
          },
          bar: {
            space: 0.3,
            width: 110
          },
          legend: {
            show: false,
            position: 'inset',
            inset: {
              anchor: 'top-left',
              x: 0,
              y: -65,
              step: 2
            },
            hide: ['units']
          },
          tooltip: {
            format: {
              value: d3.format(",.0f")
            },
            contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
              let $$ = this;
              let config = $$.config;
              let titleFormat = config.tooltip_format_title || defaultTitleFormat;
              let nameFormat = config.tooltip_format_name || function (name) { return name; };
              let valueFormat = config.tooltip_format_value || defaultValueFormat;

              return lodash.reduce(d, (text, data) => {
                if (!data && (data.value || data.value === 0)) { return text; }

                if (text === '') {
                  let title = titleFormat ? titleFormat(data.x) : data.x;
                  text = "<table class='" + $$.CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + "</th></tr>" : "");
                }

                let name = nameFormat(data.name);
                let value = valueFormat(data.value, data.ratio, data.id, data.index);
                let bgcolor = $$.levelColor ? $$.levelColor(data.value) : color(data.id);

                text += "<tr class='" + $$.CLASS.tooltipName + "-" + d.id + "'>";
                text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + "</td>";
                text += "<td class='value'>" + value + "</td>";
                text += "</tr>";
                return text;
              }, '') + "</table>";
            }
          }
        };
      }
    },
  };
</script>
